import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/leads')({
  beforeLoad: () => {
    requireRouteAccess('/leads');
    throw redirect({ to: '/admin/admissions', search: { view: 'list' }, replace: true });
  },
});
